import clsx from "clsx";
import { InputHTMLAttributes, ReactNode } from "react";

import "../InputRadio/styles.css";

export interface InputRadioUncontrolledProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: ReactNode;
  labelClassName?: string;
  wrapperClassName?: string;
}

export const InputRadioUncontrolled = ({
  checked,
  className,
  disabled,
  id,
  label,
  labelClassName,
  wrapperClassName,
  ...props
}: InputRadioUncontrolledProps) => {
  return (
    <div className={clsx("input-radio", wrapperClassName)}>
      <input
        id={id}
        type="radio"
        className={clsx("hidden", disabled ? "cursor-default" : "cursor-pointer", className)}
        checked={checked}
        disabled={disabled}
        {...props}
      />

      <label
        htmlFor={id}
        className={clsx("options-label relative", labelClassName, {
          disabled,
          "opacity-50": disabled,
          selected: checked,
        })}
      >
        {label}
      </label>
    </div>
  );
};
